export default {
  header: {
    hideMenuBar: 'Menüleiste verbergen',
    showMenuBar: 'Menüleiste anzeigen'
  }
}
